import { Dist } from "./Dist";
import { AMember, Material, WallType } from "./internalModules";

/**Returns a random item from an array */
function randomItem<T>( array: T[]): T{
    let index = Math.floor(Math.random() * array.length);
    return array[index];
}

/**Merges items from another Map. If keys overlap, the values are added */
function mapMerge( map: Map<string, number>, mergeMap: Map<string, number>){
  for (const key of mergeMap.keys()){
    if (map.has(key)) {
      const currentValue = map.get(key)!
      const newValue = currentValue + mergeMap.get(key)!
      map.set(key, newValue)
    }
    else {
      map.set(key, mergeMap.get(key)!)
    }
  }
  return map
}

/**Returns the sum of values in a Map */
function mapSum( map: Map<string, number>): number {
  let sum = 0
  for (const val of map.values()) {
    sum += val
  }
  return sum
}

/**Multiplies each value in the input map by a number */
function mapMultiply( map: Map<string, number>, number: number){
  for (const key of map.keys()) {
    const newValue = map.get(key)! * number
    map.set(key, newValue)
  }
  return map
}

/**Groups items in an array by a property */
//from here: https://gist.github.com/robmathers/1830ce09695f759bf2c4df15c29dd22d
const groupBy = <T>(arr: T[], keys: (keyof T)[]): { [key: string]: T[] } => {
  return arr.reduce((storage, item) => {
    const objKey = keys.map(key => `${ item[key] }`).join(':');
    if (storage[objKey]) {
      storage[objKey].push(item);
    } else {
      storage[objKey] = [item];
    }
    return storage;
  }, {} as { [key: string]: T[] });
}

function getCurrentDateTimeAsString(): string {
  const now = new Date()
  const y = now.getFullYear()
  const mo = now.getMonth() + 1
  const d = now.getDate()
  const h = now.getHours()
  const m = now.getMinutes()
  const s = now.getSeconds()
  return `${y}-${mo}-${d}_${h}${m}${s}`
}

/**Returns the number of times a substring occurs in the main string.*/
function countOccurrences(mainString: string, subString: string): number {
  return mainString.split(subString).length - 1
}

function checkDependency(itemToCheck: WallType|AMember, guid: string): boolean {
  let item: AMember|WallType = itemToCheck as AMember
  if(item && item.materialGuid === guid){
    return true
  }
  item = itemToCheck as WallType
  if(item){
    // check layers
    for(const layer of item.getAllLayers()){
      if(layer.materialGuid === guid){
        return true
      }
      if(layer.fillMaterialGuid === guid){
        return true
      }
      if(layer.memberGuid === guid){
        return true
      }
    }
  }
  return false
}

function getDependentGuids(itemToCheck: WallType|AMember): string[] {
  let dependents: string[] =[]
  let item: AMember|WallType = itemToCheck as AMember
  if(item instanceof AMember){
    dependents.push(item.materialGuid)
    dependents = Array.from(dependents.filter(x=>x.length > 1))
    return dependents
  }
  item = itemToCheck as WallType
  if(item instanceof WallType){
    for(const layer of item.getAllLayers()){
      dependents.push(layer.materialGuid)
      dependents.push(layer.fillMaterialGuid)
      dependents.push(layer.memberGuid)
    }
  }
  dependents = Array.from(dependents.filter(x=>x.length > 1))
  return dependents
}

/**Returns a string with only characters allowed in distances. */
function sanitizeLengthString(input: string): string {
  const regex = /[^0-9'?"?\/?\.?\s?]*/gi
  return input.replaceAll(regex, '')
}

/**Parses the input text into a distance.*/
function parseDistText(input: string): Dist{
  // if input has ', split at '
  const sanitized = sanitizeLengthString(input)
  let feet = 0
  let inches = 0
  if(sanitized.includes(`'`)){
    const split = sanitized.split(`'`)
    feet = Number(split[0])
    inches = parseInchText(split[1])
  }
  else{
    inches = parseInchText(sanitized)
  }
  return new Dist(feet, inches)
} 

/**Returns a number of inches represented by a string.*/
function parseInchText(input: string): number{
  const text = input.replace(`"`, ``).trim() //removes inch symbol and start&end whitespace
  if (countOccurrences(input, `/`) > 1 || countOccurrences(input, `.`) > 1){
    return NaN
  }
  let inches = NaN
  let numerator = NaN
  let denominator = NaN
  if( text.includes(`/`) ){ // if input has /, split at /
    const beforeSlash = text.split(`/`)[0]
    const afterSlash = text.split(`/`)[1]
    denominator = Number(afterSlash)
    if(beforeSlash.includes(` `)){
      inches = Number(beforeSlash.split(` `)[0])
      numerator = Number(beforeSlash.split(` `)[1])
    }
    else{
      inches = 0
      numerator = Number(beforeSlash)
    }
    inches += numerator/denominator
  }
  else{
    inches = Number(text)
  }
  return inches
}

export {
  randomItem, 
  mapMerge, 
  mapSum, 
  mapMultiply, 
  groupBy, 
  getCurrentDateTimeAsString,
  countOccurrences,
  getDependentGuids,
  sanitizeLengthString,
  parseDistText
}